import { Box, IconButton } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import theme from "../../configs/theme";

export default function NoteUI({ note, rol, onDelete }) {
  const formattedDate = (() => {
    const date = new Date(note.created_at);
    const formatter = new Intl.DateTimeFormat("es-AR", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    const parts = formatter.formatToParts(date);
    const day = parts.find(p => p.type === "day").value;
    const month = parts.find(p => p.type === "month").value;
    const hour = parts.find(p => p.type === "hour").value;
    const minute = parts.find(p => p.type === "minute").value;
    return `${day}/${month} ${hour}:${minute}`;
  })();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        bgcolor: theme.colors.primary,
        border: "1px solid black",
        borderRadius: 4,
        mb: 1,
      }}
    >
      <Box
        sx={{
          pl: 2,
          py: 1,
          borderBottom: "1px solid black",
        }}
      >
        {formattedDate} - {note.author}
        {rol === "Jefe" && (
          <IconButton
            onClick={onDelete}
            size="small"
            sx={{ float: "right" }}
          >
            <CheckIcon fontSize="inherit" sx={{ color: "white" }} />
          </IconButton>
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          py: 1,
          px: 2,
          mt: 0.5,
          wordBreak: "break-word",
          whiteSpace: "pre-wrap",
        }}
      >
        {note.description}
      </Box>
    </Box>
  );
}
